var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vs-con-loading__container",class:{
    '_cover': _vm.cover
  },attrs:{"id":"loader-block"}},[(_vm.hasDefaultSlot)?_vm._t("default"):_vm._e(),_c('div')],2)}
var staticRenderFns = []

export { render, staticRenderFns }